module.exports = __webpack_public_path__ + "img/77.fee508b7.png";